export default __webpack_public_path__ + "static/media/icons.3db8c577.svg";